export default __webpack_public_path__ + "static/media/Brow_3_C2.f73853ae.svg";